import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { REMOVE_APPLICATION_GROUP, ADD_APPLICATION_GROUP, REPLICATE_APPLICATION_GROUP } from "../../../store/application-actions";
import { SET_PROPERTY_ORDER } from "../../../store/application-mutations";
import { mapActions, mapMutations } from "vuex";
import { createHelpers } from "@joandvgv/vuex-map-fields";
import * as FieldComponents from "@Shared/components/sections/index";
import DuplicatorMixin from "@Shared/utils/application-mixins/duplicator-mixin";
import VisibilityToggleMixin from "@Shared/utils/application-mixins/visibility-toggle-mixin";
import PropertyMixin from "@Broker/@Modules/clients/applications/application/select-options/property-mixin";
import MortgageDetailsMixin from "@Broker/@Modules/clients/applications/application/select-options/mortgage-details-mixin";
import { getFullNameWithSalutationFrom } from "@Shared/utils/utils";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import ApplicationCardHeader from "@Broker/@Modules/util-components/application-card-header";
import { kebabCase, mapValues } from "lodash";
import ResizeSensor from "@Shared/utils/resize-sensor";
import { PagesVisibilityMap } from "@Broker/@Utils/application/pages-visibility-map.ts";
import MultipleVisibilityButton from "@Broker/@Modules/clients/applications/application/components/pages-components/application/util-components/multiple-visibility-button.vue";
import { isEmpty } from "lodash";
const {
  mapFields,
  mapMultiRowFields
} = createHelpers({
  getterType: "getDetails",
  mutationType: "setDetails"
});
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PropertyOwned",
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    InlinePrompt,
    ApplicationCardHeader,
    ResizeSensor,
    MultipleVisibilityButton
  }),
  mixins: [DuplicatorMixin, VisibilityToggleMixin, PropertyMixin, MortgageDetailsMixin],
  props: {
    currentApplication: {
      type: Object,
      required: true
    },
    applicantIndex: {
      type: Number,
      required: true
    },
    propertyIndex: {
      type: [Number, String],
      required: true
    },
    property: {
      type: Object,
      default: () => ({})
    },
    applicantSelectOptions: {
      type: Array,
      required: true
    },
    arrayIndex: {
      type: Number,
      default: null
    },
    allProperties: {
      type: Array,
      default: () => []
    },
    applicant: {
      type: Object,
      required: true
    },
    editVisibility: {
      type: Boolean,
      default: false
    },
    applicantKey: {
      type: String,
      default: ""
    },
    isMainApplicantScreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      PagesVisibilityMap
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({
    paths() {
      const {
        applicantIndex,
        propertyIndex,
        getApplicantKey
      } = this;
      const root = `${getApplicantKey(applicantIndex)}[other-properties][${propertyIndex}]`;
      const details = `${root}[property-details]`;
      const costs = `${root}[property-costs]`;
      const rental = `${root}[property-rental]`;
      const mortgageDetails = "mortgage-details";
      return {
        address: details,
        includeInTds: costs,
        occupancy: rental,
        purchasePrice: details,
        estimatedValue: details,
        purchaseDate: details,
        propertyTaxes: costs,
        maintenanceFees: costs,
        percOfTotalMaintFees: costs,
        feesIncludeHeat: costs,
        heating: costs,
        monthlyIncome: rental,
        rentalIncomeOptions: rental,
        rentalIncomeOptionsPercent: rental,
        hydro: rental,
        others: rental,
        management: rental,
        insurance: rental,
        repairs: rental,
        interest: rental,
        otherPropertyExistingMortgages: root,
        downPayment: mortgageDetails,
        propertyEquity: root
      };
    },
    visibilityPaths() {
      return mapValues(this.paths, (path, key) => `${path}[${kebabCase(key)}]`);
    }
  }, mapFields("ApplicationStore", {
    address() {
      return this.paths.address;
    },
    propertyEquity() {
      return this.paths.propertyEquity;
    },
    includeInTds() {
      return this.paths.includeInTds;
    },
    occupancy() {
      return this.paths.occupancy;
    },
    purchasePrice() {
      return this.paths.purchasePrice;
    },
    estimatedValue() {
      return this.paths.estimatedValue;
    },
    purchaseDate() {
      return this.paths.purchaseDate;
    },
    propertyTaxes() {
      return this.paths.propertyTaxes;
    },
    maintenanceFees() {
      return this.paths.maintenanceFees;
    },
    percOfTotalMaintFees() {
      return this.paths.percOfTotalMaintFees;
    },
    feesIncludeHeat() {
      return this.paths.feesIncludeHeat;
    },
    heating() {
      return this.paths.heating;
    },
    monthlyIncome() {
      return this.paths.monthlyIncome;
    },
    rentalIncomeOptions() {
      return this.paths.rentalIncomeOptions;
    },
    rentalIncomeOptionsPercent() {
      return this.paths.rentalIncomeOptionsPercent;
    },
    hydro() {
      return this.paths.hydro;
    },
    others() {
      return this.paths.others;
    },
    management() {
      return this.paths.management;
    },
    insurance() {
      return this.paths.insurance;
    },
    repairs() {
      return this.paths.repairs;
    },
    interest() {
      return this.paths.interest;
    }
  })), mapMultiRowFields("ApplicationStore", {
    otherPropertyExistingMortgages() {
      return this.paths.otherPropertyExistingMortgages || [];
    },
    downPayment() {
      return this.paths.downPayment;
    }
  })), {}, {
    occupancyPaths() {
      const {
        occupancy,
        monthlyIncome,
        rentalIncomeOptions,
        rentalIncomeOptionsPercent,
        hydro,
        heating,
        others,
        insurance,
        interest,
        repairs,
        management
      } = this.visibilityPaths;
      return [occupancy, monthlyIncome, rentalIncomeOptions, rentalIncomeOptionsPercent, hydro, heating, others, insurance, interest, repairs, management];
    },
    applicantFullNameWithSalutation() {
      const {
        "personal-details": personalDetails
      } = this.applicant;
      return getFullNameWithSalutationFrom(personalDetails);
    },
    missingDescription() {
      return !this.address || !this.address.line1;
    },
    isMissingValue() {
      return isEmpty(this.property["property-equity"]) || Number(this.property["property-equity"]) === 0;
    },
    tiedDownpayment() {
      var _context;
      if (!this.address || !this.address.line1) {
        return false;
      }
      return !!_findInstanceProperty(_context = this.downPayment).call(_context, ({
        description
      }) => {
        return description === this.address.line1;
      });
    },
    remainingMortgagesTypeOptions() {
      var _context2, _context3;
      const mortgageTypes = _mapInstanceProperty(_context2 = this.property["other-property-existing-mortgages"]).call(_context2, mortgage => mortgage["mortgage-type"]);
      const setMortgageTypes = new _Set(mortgageTypes);
      return _mapInstanceProperty(_context3 = this.mortgageTypeOptions).call(_context3, option => _objectSpread(_objectSpread({}, option), {}, {
        disabled: setMortgageTypes.has(option.value)
      }));
    },
    showHydroFeesInput() {
      return this.visibilityToggle(this.currentApplication, this._visibilityDataContext, `${this.getApplicantKey(this.property["applicantIndex"])}[other-properties][${this.propertyIndex}]]['property-rental']['occupancy']`, this.occupancyActionTypeOptions, "hydro");
    },
    showOtherFeesInput() {
      return this.visibilityToggle(this.currentApplication, this._visibilityDataContext, `${this.getApplicantKey(this.property["applicantIndex"])}[other-properties][${this.propertyIndex}]]['property-rental']['occupancy']`, this.occupancyActionTypeOptions, "others");
    },
    showManagementFeesInput() {
      return this.visibilityToggle(this.currentApplication, this._visibilityDataContext, `${this.getApplicantKey(this.property["applicantIndex"])}[other-properties][${this.propertyIndex}]]['property-rental']['occupancy']`, this.occupancyActionTypeOptions, "management");
    },
    showInsuranceFeesInput() {
      return this.visibilityToggle(this.currentApplication, this._visibilityDataContext, `${this.getApplicantKey(this.property["applicantIndex"])}[other-properties][${this.propertyIndex}]]['property-rental']['occupancy']`, this.occupancyActionTypeOptions, "insurance");
    },
    showRepairsFeesInput() {
      return this.visibilityToggle(this.currentApplication, this._visibilityDataContext, `${this.getApplicantKey(this.property["applicantIndex"])}[other-properties][${this.propertyIndex}]]['property-rental']['occupancy']`, this.occupancyActionTypeOptions, "repairs");
    },
    showInterestFeesInput() {
      return this.visibilityToggle(this.currentApplication, this._visibilityDataContext, `${this.getApplicantKey(this.property["applicantIndex"])}[other-properties][${this.propertyIndex}]]['property-rental']['occupancy']`, this.occupancyActionTypeOptions, "interest");
    },
    extraFeesInformationIsNeeded() {
      return this.showHydroFeesInput || this.showOtherFeesInput || this.showManagementFeesInput || this.showInsuranceFeesInput || this.showRepairsFeesInput || this.showInterestFeesInput;
    },
    applicantType() {
      return this.applicantIndex == "0" ? "main-applicant" : "co-applicants";
    }
  }),
  watch: {
    extraFeesInformationIsNeeded(value) {
      if (!value) this.$emit("height-remove", `property-fees-${this.propertyIndex}`, {
        otherProperties: true
      });
    }
  },
  mounted() {
    this.setPropertyOrder(this.property.order);
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("ApplicationStore", [REMOVE_APPLICATION_GROUP, ADD_APPLICATION_GROUP, REPLICATE_APPLICATION_GROUP])), mapMutations("ApplicationStore", [SET_PROPERTY_ORDER])), {}, {
    setPropertyOrder(order) {
      const {
        applicantIndex,
        propertyIndex,
        getApplicantKey
      } = this;
      this.SET_PROPERTY_ORDER({
        path: `${getApplicantKey(applicantIndex)}[other-properties][${propertyIndex}]`,
        order
      });
    },
    handleVisibility(data) {
      this.$emit("toggle-visibility", data);
    },
    handleRemove(index, where, startEmpty) {
      this.REMOVE_APPLICATION_GROUP({
        index,
        where,
        startEmpty
      });
      if (!_includesInstanceProperty(where).call(where, "existing-mortgages")) this.$emit("remove-property");
      this.$emit("height-remove", `existing-mortgages-${this.propertyIndex}`, {
        otherProperties: true
      });
      this.$emit("save");
    },
    getApplicantKey(applicantIndex) {
      return applicantIndex === 0 ? "main-applicant" : `co-applicants[${applicantIndex - 1}]`;
    },
    getOtherPropertyExistingMortgagesKey(propertyIndex, applicantIndex) {
      return `${this.getApplicantKey(applicantIndex)}[other-properties][${propertyIndex}][other-property-existing-mortgages]`;
    },
    async addDownPayment() {
      const payload = {
        amount: this.property["property-equity"],
        source: "sales-of-existing-property",
        description: this.address.line1
      };
      const [firstDownPayment] = this.downPayment;
      let isEmptyDownPayment = !firstDownPayment.source && !firstDownPayment.description;
      if (this.downPayment.length === 1 && isEmptyDownPayment) {
        for (const key in payload) {
          firstDownPayment[key] = payload[key];
        }
      } else {
        const where = "['mortgage-details']['down-payment']";
        await this.ADD_APPLICATION_GROUP({
          what: payload,
          where
        });
      }
      this.$emit("page-change", "mortgage-details");
      this.navigateTo("mortgage-details-container");
      this.$emit("save");
    },
    changePropertyOwnership(applicantIndex) {
      this.$emit("change-ownership", applicantIndex);
    },
    handleDuplicate({
      what,
      where,
      markAsVisible,
      startEmpty
    }) {
      this.ADD_APPLICATION_GROUP({
        what,
        where,
        markAsVisible,
        startEmpty
      });
      this.$emit("save");
    },
    handleReplicateAddress() {
      const targetPath = this.applicantKey + `[other-properties][${this.arrayIndex}][property-details]`;
      this.REPLICATE_APPLICATION_GROUP({
        path: `${this.applicantKey}[personal-details][addresses]`,
        index: 0,
        targetPath,
        key: "address"
      });
      this.$emit("replicate");
    },
    handleSave() {
      this.$emit("save");
    },
    handleResize(path) {
      this.$emit("change-height", path, {
        otherProperties: true
      });
    },
    tabIndex(value) {
      return this.applicantIndex === 1 ? value + 1 : value;
    },
    navigateTo(element, duration = 500) {
      this.$nextTick(() => {
        this.$scrollTo(`#${element}`, duration, {
          container: "#app-data-container",
          offset: -50,
          force: true,
          cancelable: true
        });
      });
    }
  })
});